






































































































































import { Component, Ref, Vue } from 'vue-property-decorator';
import { PRODUCT_LIST_SEARCH } from '@/queries/Product';
import ProductNewButton from '@/components/Product/ProductNewButton.vue';
import ProductEditButton from './ProductEditButton.vue';
import ProductShowButton from './ProductShowButton.vue';
import ProductDeleteButton from './ProductDeleteButton.vue';
import { ACTIVE_VAT_RATES } from '@/queries/ClientQueries';
import { SmartQuery } from 'vue-apollo-decorator';
import PermissionService from '@/utils/permission-service';
import { GQL_currentUnitProductGroups, GQL_currentUnitProductGroups_currentUnit_productGroups } from '@/queries/__generated__/currentUnitProductGroups';
import { ALL_PRODUCT_GROUPS } from '@/queries/ProductGroup';
import SApolloTable from '@/components/UI/Table/SApolloTable.vue';
import { GQL_productListSearch_products } from '@/queries/__generated__/productListSearch';
import { sortProductGroups } from '@/app/ProductGroup';
import { GQL_activeNorwegianVatRates, GQL_activeNorwegianVatRates_activeNorwegianVatRates } from '@/queries/__client__/activeNorwegianVatRates';

@Component({
  components: {
    ProductNewButton,
    ProductEditButton,
    ProductShowButton,
    ProductDeleteButton,
  },
})
export default class ProductList extends Vue {
  private PermissionService = PermissionService;
  @Ref() private table?: SApolloTable<GQL_productListSearch_products>;

  @SmartQuery<ProductList, GQL_activeNorwegianVatRates, { date: string }>({
    query: ACTIVE_VAT_RATES,
    variables() {
      return { date: this.today };
    },
  }) public activeNorwegianVatRatesMap!: Map<string, GQL_activeNorwegianVatRates_activeNorwegianVatRates>;

  @SmartQuery<ProductList, GQL_currentUnitProductGroups>({
    query: ALL_PRODUCT_GROUPS,
    update: data => sortProductGroups(data.currentUnit.productGroups),
    fetchPolicy: 'no-cache',
  }) public productGroups!: GQL_currentUnitProductGroups_currentUnit_productGroups[];

  private PRODUCT_LIST_SEARCH = PRODUCT_LIST_SEARCH;
  private today = this.$dayjs().format('YYYY-MM-DD');
  private activeDate = this.today;

  private get productGroupSelectOptions(): { [value: string]: string } {
    const productGroupsOptions = (this.productGroups || [])
      .reduce((obj, p) => {
        // Ugly hack in order to sort the options nicely.
        // If there are only numbers in the object, they are sorted by
        // those numbers first, and then by the order of addition of the key.
        // Even tho id is a string, it behaves as an numeric index in object.
        // https://stackoverflow.com/questions/5467129/sort-javascript-object-by-key
        obj[` ${p.id}`] = p.fullPathName;
        return obj;
      }, {} as { [value: string]: string });

    return {
      'none': this.$t('none').toString(),
      ...productGroupsOptions,
    };
  }

  private activePeriodDisplay(product: GQL_productListSearch_products) {
    const activeDate = this.$dayjs.strict(this.activeDate).isValid() ? this.activeDate : this.$dayjs();

    const activePeriod = product.productActivePeriods.find(period => {
      return (
        this.$dayjs.strict(period.activeFrom).isSameOrBefore(activeDate) &&
        (
          !period.activeTo ||
          this.$dayjs.strict(period.activeTo).isSameOrAfter(activeDate)
        )
      );
    }) || product.productActivePeriods[product.productActivePeriods.length - 1];

    return `${activePeriod?.activeFrom || ''} - ${activePeriod?.activeTo || ''}`;
  }

  private vatRateDisplay(symbol: string) {
    const vatRate = this.activeNorwegianVatRatesMap.get(symbol);
    if (!vatRate) return `?`;
    return `${vatRate.rate}%`;
  }

  private resetTableResult() {
    this.table?.refetch();
  }
}
